import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter } from '@/components/ui/dialog';
import { PodgladPliku } from '@/components/PodgladPliku';
import { useI18n } from '@/lib/i18n';

/**
 * CO NAPRAWDĘ LEŻY NA TEJ MASZYNIE — okno wokół podglądu JEDNEGO pliku z jej katalogu grafik.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ ZGŁOSZONE (31.08.2026): „na obecnej liście, gdy plik się nie zgadza, to możliwość
 *  wyświetlenia go — tym samym kanałem pewnie co obecnie screenshot". Ekran pokrycia umiał
 *  powiedzieć „ta maszyna wskazuje `dupa.jpg`" albo „ten sam plik ma inną treść" — i nie dawał
 *  tego zobaczyć, czyli nie odpowiadał na jedyne pytanie, jakie się wtedy ma.
 *
 *  ⚠️⚠️ OD 07.09.2026 TO JUŻ TYLKO OPRAWA. Pobieranie, podgląd i zapis do biblioteki siedzą
 *  w `PodgladPliku`, bo to samo jest potrzebne w naprawie wiersza („ściągnij i rozgłoś"). Dwie
 *  kopie pobierania rozjechałyby się przy pierwszej zmianie kanału, a rozjazd byłby CICHY: jedno
 *  okno pokazywałoby plik, drugie „czekam" bez końca.
 *
 *  ⚠️ ZAPIS DO BIBLIOTEKI JEST TU WŁĄCZONY (`onZapisano`), bo to najczęstsza droga do niego:
 *  człowiek klika ikonkę przy maszynie, żeby OBEJRZEĆ plik, i wtedy właśnie okazuje się, że ten
 *  jest dobry i chce go u siebie. Bez tego przycisku trzeba by wyjść i wejść inną drogą.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */
export function PodgladZMaszyny({
  groupId,
  agentId,
  nazwaMaszyny,
  nodeId,
  nazwaPliku,
  wBibliotece,
  onClose,
}: {
  groupId: string;
  agentId: string;
  nazwaMaszyny: string;
  /** Krótki identyfikator węzła — wchodzi do podpowiedzianej nazwy pliku przy zapisie. */
  nodeId: string;
  nazwaPliku: string;
  /** Nazwy plików, które biblioteka już ma — do podpowiedzi nazwy przy kolizji. */
  wBibliotece?: readonly string[];
  onClose: () => void;
}) {
  const { t } = useI18n();

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="w-[min(46rem,calc(100vw-2rem))]"
        title={t('podgladM.tytul')}
        description={t('podgladM.opis').replace('{maszyna}', nazwaMaszyny).replace('{plik}', nazwaPliku)}
      >
        <PodgladPliku
          groupId={groupId}
          agentId={agentId}
          nodeId={nodeId}
          nazwaPliku={nazwaPliku}
          wBibliotece={wBibliotece}
          /** ⚠️ Pusty odbiorca, ale OBECNY: to on włącza przycisk zapisu w środku. */
          onZapisano={() => undefined}
        />

        <DialogFooter>
          <Button type="button" onClick={onClose}>
            {t('common.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
